import { render, staticRenderFns } from "./TheGameListItem.vue?vue&type=template&id=276d0b59"
import script from "./TheGameListItem.vue?vue&type=script&lang=js"
export * from "./TheGameListItem.vue?vue&type=script&lang=js"
import style0 from "./TheGameListItem.vue?vue&type=style&index=0&id=276d0b59&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports